import React, { useEffect, useState } from "react";
import PremiumRegistrations from "../home/components/PremiumRegistrations";
import { apiRequest } from "../../utils/api";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../home/components/Loader";
import { addData, getData } from "../../utils/storage";
import { errorToast } from "../../utils/Toast";
import { extractNumber } from "../../utils/function";

function OpenSalePlates() {
  const { number, keyword } = useParams();
  const [plates, setPlates] = useState([]);
  const [plate, setPlate] = useState(getData("search-plate") || keyword || "");
  const [page, setPage] = useState(number || 1);
  const [nextPlates, setNextPlates] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dynamicImage, setDynamicImage] = useState("");
  const [dynamicImageStatus, setDynamicImageStatus] = useState("");
  const [dynamicBanner, setDynamicBanner] = useState("");
  const [dynamicStyles, setDynamicStyles] = useState({});

  async function getDynamicImage() {
    try {
      let res = await apiRequest.get(`/dynamic-image/single/1`);
      if (res.data.status == 200) {
        setDynamicImage(res.data.message?.url);
        setDynamicImageStatus(res.data.message?.status);
      }
    } catch (error) {}
  }

  async function getDynamicBanner(area = "banner") {
    try {
      let res = await apiRequest.get(`/dynamic-text/texts/${area}`);
      if (res.data.status == 200) {
        setDynamicBanner(res.data.message[0]);
        setDynamicStyles(JSON.parse(res.data.message[0]?.styles));
      }
    } catch (error) {}
  }

  useEffect(() => {
    getDynamicBanner("banner");
    getDynamicImage();
  }, []);

  // Sync page when URL param changes
  useEffect(() => {
    setPage(number || 1);
  }, [number]);

  useEffect(() => {
    fetchPlates();
    fetchNextPage();
  }, [page]);

  async function fetchPlates() {
    setIsLoading(true);
    try {
      let res = await apiRequest.get(`/open-sale/search/${plate}/${page}`);
      if (res.data.status === 200) {
        setPlates(
          res.data.message.map((r) => ({
            fullNumber: r.fullNumber?.replace(
              extractNumber(r.fullNumber),
              `${extractNumber(r.fullNumber)} `
            ),
            price: r.price,
          }))
        );
      } else {
        setPlates([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
    window.scrollTo(0, 600);
  }

  async function fetchNextPage() {
    try {
      let res = await apiRequest.get(
        `/open-sale/search/${plate}/${parseInt(page) + 1}`
      );
      if (res.data.status === 200) {
        setNextPlates(res.data.message);
      } else {
        setNextPlates([]);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function submitForm(e) {
    e.preventDefault();
    if (!plate) return errorToast("Please Enter Number");
    addData("search-plate", plate);
    window.location.href = `/search/${plate}`;
  }

  return (
    <div>
      {isLoading && <Loader />}
      <div className="home-banner">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="banner-serch-bar">
                <div className="banner-serch-bar-title">
                  <h2>We Make Buying Registrations Fast &amp; Easy...</h2>
                  {dynamicBanner && (
                    <div
                      style={{
                        fontSize: dynamicStyles.fontSize,
                        fontWeight: dynamicStyles.fontWeight,
                        marginBottom: "16px",
                      }}
                    >
                      {dynamicBanner?.content}
                    </div>
                  )}
                  {!dynamicBanner && (
                    <h3>12-48 months finance on order over £250</h3>
                  )}
                </div>
                <form onSubmit={submitForm}>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your initials, name, car or anything else..."
                      value={plate}
                      onChange={(e) => setPlate(e.target.value)}
                    />
                    <button className="btn btn-dark" type="submit">
                      Search
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-md-6">
              <div className="car-img">
                {dynamicImageStatus === "active" ? (
                  <img src={dynamicImage} crossOrigin="anonymous" alt="Banner" />
                ) : (
                  <img src="/img/number-car.png" alt="Banner" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {plates?.length > 0 ? (
        <>
          <PremiumRegistrations
            title={`OPEN SALE '${getData("search-plate")?.toUpperCase()}' REGISTRATIONS`}
            plates={plates}
            page={"open-sale"}
            plate={getData("search-plate")}
          />
          <div className="container">
            <div className="row mb-5">
              <div className="col-4"></div>
              <div className="col-4"></div>
              <div className="col-4">
                <div className="view-button">
                  {page != 1 && (
                    <button
                      className="btn btn-dark"
                      onClick={() => {
                        window.location.href = `/open-sale/${plate}/${parseInt(page) - 1}`;
                      }}
                    >
                      Previous
                    </button>
                  )}
                  {nextPlates.length > 0 ? (
                    <button
                      className="btn btn-warning"
                      onClick={() => {
                        window.location.href = `/open-sale/${plate}/${parseInt(page) + 1}`;
                      }}
                    >
                      Next
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : !isLoading ? (
        <div className="container my-5 text-center">
          <p className="text-muted">No Open Sale registrations found for "{plate}".</p>
        </div>
      ) : null}
    </div>
  );
}

export default OpenSalePlates;
